import { render, staticRenderFns } from "./ListBook.vue?vue&type=template&id=04555c08&"
import script from "./ListBook.vue?vue&type=script&lang=js&"
export * from "./ListBook.vue?vue&type=script&lang=js&"
import style0 from "./ListBook.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports